<template lang="jade">
  div(style="display: none")
</template>
<script>
import _ from 'lodash'
import { setNavigation, clearAllNotifications, setWorkflow } from 'src/vuex/actions'
import { forms, workflow } from 'src/vuex/getters'
import { Submit } from 'src/services/resources'

export default {
  data () {
    return {
      uid: this.$parent.uid
    }
  },
  computed: {
    steps () {
      let steps = this.fdata.content
      return _.map(steps, xs => {
        xs.active = _.includes(xs.class.match(/\w+/g), 'active')
        xs.cb = this.click
        return xs
      })
    },
    form () {
      return _.find(this.forms, ['uid', this.uid])
    },

    headers () {
      let header = _.find(this.workflow, ['uid', this.uid])
      return {
        headers: {
          'X-FORMID': header.fid,
          'X-FINGERPRINT': header.fingerprint,
          'X-SITEID': header.sid
        }
      }
    }
  },
  props: {
    fdata: {
      type: Object
    }
  },
  vuex: {
    getters: {
      forms,
      workflow
    },
    actions: {
      setNavigation,
      clearAllNotifications,
      setWorkflow
    }
  },
  methods: {
    click (step) {
      Submit.post({button: step.buttonId}, this.headers)
            .then(_.partial(this.success, step))
    },

    success (step, res) {
      let openAs = step.openAs === '' ? 'normal'
                                      : step.openAs
      let evt = {'top': 'set::workflow',
                 'normal': 'add::workflow',
                 'popUp': 'modal::workflow',
                 'newWindow': 'tab::workflow'}

      this.clearAllNotifications()
      let {data} = res
      let workflow = _.isUndefined(data.content) ? data : data.content
      workflow.fingerprint = data.fingerprint
      this.$dispatch(evt[openAs], workflow)
    }
  },
  ready () {
    this.setNavigation(this.steps)
  }
}
</script>



// WEBPACK FOOTER //
// navbar.vue?a45d9aea